import { models, IEmbedConfiguration } from 'powerbi-client';
import { IFilter } from 'powerbi-models';
import { PbiAuthorization } from '../../types/PbiTypes';

export default () => {
    const getEmbeddedConfiguration = (pbiAuthorization: PbiAuthorization, reportName: string, filter?: IFilter, pageName?: string) => {
        const report = pbiAuthorization?.reports?.find((r) => r.reportName === reportName.toString());
        if (!report) return;
        const embedConfiguration: IEmbedConfiguration = {
            type: 'report',
            tokenType: models.TokenType.Embed,
            accessToken: pbiAuthorization.token,
            embedUrl: report.embedUrl,
            id: report.reportId,
            permissions: models.Permissions.All,
            pageName: pageName ? pageName : '',
            settings: {
                //background: models.BackgroundType.Transparent,
                filterPaneEnabled: false,
                navContentPaneEnabled: false,
            },
            filters: [filter],
        };

        return embedConfiguration;
    };

    return { getEmbeddedConfiguration };
};
